import Keycloak from "keycloak-js";


let envs = {};
let envsLocal = {
  REACT_APP_KEYCLOAK_CLIENT_ID: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  REACT_APP_KEYCLOAK_REALM: process.env.REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_URL: process.env.REACT_APP_KEYCLOAK_URL,
};

const getEnv = () => {
    if (process.env.NODE_ENV === "development") {
        return (envs = envsLocal);
    } else {
        return (envs = window._env_);
    }
};

getEnv();

const keycloakConfig = {
  url: envs.REACT_APP_KEYCLOAK_URL,
  realm: envs.REACT_APP_KEYCLOAK_REALM,
  clientId: envs.REACT_APP_KEYCLOAK_CLIENT_ID,
};

// Validate that all required environment variables are set
const missingVars = [];
if (!keycloakConfig.url) missingVars.push('REACT_APP_KEYCLOAK_URL');
if (!keycloakConfig.realm) missingVars.push('REACT_APP_KEYCLOAK_REALM');
if (!keycloakConfig.clientId) missingVars.push('REACT_APP_KEYCLOAK_CLIENT_ID');

if (missingVars.length > 0) {
  throw new Error(
    `Missing required environment variables: ${missingVars.join(', ')}. ` +
    `Please check your .env file.`
  );
}


const keycloak = new Keycloak(keycloakConfig);

export default keycloak;